// ACCOUNT
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const LOGOUT = 'LOGOUT';

// ENERGYSCREEN
export const SET_SCREEN = 'SET_SCREEN';

//SLIDES
export const SET_SLIDES = 'SET_SLIDES';
export const ADD_SLIDE = 'ADD_SLIDE';